// 🎓 Niveau choisi par l'élève dans la recherche (suite du tour 58) : quand la recherche a un niveau
// précis (pas une famille comme « Lycée ») et que l'annonce l'enseigne, l'onglet le retient pour cette
// annonce (sessionStorage) en ouvrant la fiche ou en allant réserver. Il part ensuite avec la demande ou
// la réservation. L'API le garde sur le cours s'il est un niveau de l'annonce, et la note du carnet de
// suivi le reprend par défaut. Une recherche sans niveau n'efface pas celui déjà retenu.
const gradeKey = (advertId) => `acadeclic:niveau:${advertId}`;
const isId = (value) => /^[0-9a-f]{24}$/i.test(String(value || ""));
const sessionStore = () => {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
};

// À l'ouverture de la fiche ou de la réservation depuis la recherche
export const rememberGrade = (advert, levelId, storage = sessionStore()) => {
  if (!advert?._id || !isId(levelId)) return;
  const taught = (advert.grades || advert.grade || []).map((g) => String(g?._id || g));
  if (!taught.includes(String(levelId))) return;
  try {
    storage?.setItem(gradeKey(advert._id), String(levelId));
  } catch (e) {
    // Stockage indisponible : la réservation partira sans niveau
  }
};

// Niveau à joindre à une demande ou à une réservation (absent si l'onglet n'en a pas retenu)
export const bookingGrade = (advertId, storage = sessionStore()) => {
  try {
    const value = storage?.getItem(gradeKey(advertId));
    return isId(value) ? value : undefined;
  } catch (e) {
    return undefined;
  }
};
